module.exports = __webpack_public_path__ + "static/scale-model-of-the-grotto-in-san-antonio-texas-d3e49d804c7db739a92847b5726ace05.png";